import * as React from "react";

function SvgEditStatus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.685 13.44C6.125 9.6 3.565 0 11.885 0s5.547 8.32 3.2 13.44c3.241.884 5.533 3.26 6.938 5.816A8.96 8.96 0 1123.04 37.12a8.96 8.96 0 01-8.94-8.355c-6.08.199-13.007-.43-13.734-1.884-1.28-2.56.64-11.52 8.32-13.44zM30.72 28.16a7.68 7.68 0 11-15.36 0 7.68 7.68 0 0115.36 0zM19.818 23l6.818 6.818-1.818 1.818L18 24.818 19.818 23zm7.273 7.273L28 33l-2.727-.91 1.818-1.817z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgEditStatus;
